import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);

// Defer CSS loading for faster FCP
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    import("./styles/tailwind.css");
    import("./styles/index.css");
  });
} else {
  setTimeout(() => {
    import("./styles/tailwind.css");
    import("./styles/index.css");
  }, 50);
}

root.render(<App />);
